import type { ChatCycle } from "./types.js";

// Cycles user → tool-call → result → assistant beats across three
// products (geo-index, gwas-index, qtl-index), using the same
// .dls-row / .dls-search-dot animation primitives as the data-layer
// search demo so the motion language matches.
export const INDEX_CYCLES: ChatCycle[] = [
  {
    server: "geo-index",
    user: "Find Alzheimer brain case/control transcriptomes.",
    tool: "search_studies",
    args: [
      { k: "disease", v: '"Alzheimer disease"' },
      { k: "tissue", v: '"brain"' },
      { k: "contrast_type", v: '"case_control"' },
    ],
    result: {
      kind: "bars",
      rows: [
        { accession: "GSE5281", title: "Prefrontal cortex AD vs CTR", cases: 87, controls: 74 },
        { accession: "GSE48350", title: "Multi-region postmortem AD", cases: 173, controls: 80 },
        { accession: "GSE36980", title: "Temporal cortex AD", cases: 33, controls: 47 },
      ],
      chip: "evidence: direct",
    },
    assistant:
      "3 of 18 matched studies. All curated case/control with direct AD vs control evidence. Pull the contrast tables?",
  },
  {
    server: "gwas-index",
    user: "Show genome-wide significant APOE hits for Alzheimer's.",
    tool: "search_associations",
    args: [
      { k: "gene", v: '"APOE"' },
      { k: "trait", v: '"Alzheimer disease"' },
      { k: "max_pvalue", v: "5e-8" },
    ],
    result: {
      kind: "rows",
      rows: [
        { accession: "rs429358", title: "APOE", meta: "p=1.2e-881 · OR 3.32" },
        { accession: "rs7412", title: "APOE", meta: "p=4.1e-78 · OR 0.61" },
        { accession: "rs769449", title: "APOE", meta: "p=8.7e-55 · OR 1.88" },
      ],
      chip: "nervous_system_disorder",
    },
    assistant:
      "Top three APOE-region hits across 41 GWAS. Want ancestry-stratified summaries or the source GCSTs?",
  },
  {
    server: "qtl-index",
    user: "Any CSF pQTL studies for Alzheimer's in discovery cohorts?",
    tool: "search_studies",
    args: [
      { k: "disease", v: '"Alzheimer"' },
      { k: "tissue", v: '"CSF"' },
      { k: "qtl_type", v: '"pQTL"' },
    ],
    result: {
      kind: "rows",
      rows: [
        { accession: "PMID 33888903", title: "SomaScan", meta: "n=1,300 · EUR" },
        { accession: "PMID 35918136", title: "Olink", meta: "n=971 · EUR" },
        { accession: "PMID 36450256", title: "mass-spec", meta: "n=621 · multi" },
      ],
      chip: "qc: pass",
    },
    assistant:
      "3 discovery-grade CSF pQTL studies, all with genome-wide summary stats. Pull the cohort table?",
  },
];
